export default __webpack_public_path__ + "static/snowflake_b.f14a37c5fd953a7619a884fc731fc9aa.svg";